<template>
    <div>
        <div class="titulo-contenido">
            <h1>
                 <span class="negrita">AVISO DE</span> PRIVACIDAD
            </h1>
        </div>
    <div class="container mt-4 mb-5">
        <boton-atras nombre_ruta="Home"></boton-atras>
        <div v-if="Object.keys(data).length > 0" class="row">
          <!-- --{{Object.keys(data).length > 0 }}__ -->
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">{{ data.titulo }}</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <div class="text-aviso my-3">
                    <h5>{{ data.descripcion }}</h5>
                 </div>

                 <!-- <pre>{{ data }}</pre> -->

                <!-- CONTENIDO OBTENIDO DIRECTAMENTE DEL SITIO ACTUAL DE HACIENDA (AREA DE COLAPSES) -->
                <div class="accordion mt-4" id="accordionExample">
                    <div  v-for="(item, i) in data.contenido" :key="i" class="card">
                        <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapse'+i" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                                <span><p class="m-0">{{ item.titulo }}</p></span>
                                <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                        </div>
                        <div v-for="(item2, j) in item.contenido" :key="j" :id="'collapse'+i" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body py-1">
                                <ul>
                                    <li class="mb-0"><a :href="urlRespuesta(item2.api, item2.IdAviso, item2.Reporte, item2.Descripcion)"  target="_blank">{{ item2.titulo }} </a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- TERMINA AREA DE COLAPSES -->
            </div>

            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes img_fija">
                    <div class="sec_imagen">
                        <img src="@/assets/imagenes/aviso-de-privacidad.jpg" alt="">
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="row mt-4 row margenes tab-select"></div>
            </div>

        </div>
        <div v-else class="d-flex justify-content-center">
          <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div><div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div><div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>

        </div>
    </div>

    </div>
</template>

<script>
import botonAtras from '../button-atras.vue'
import mapFun from '@/common/map-fn-types.js';
import AvisoPrivacidad from "@/services/AvisoPrivacidad/AvisoPrivacidad.service.js";
import { data } from 'jquery';
const _serviciosAvisoPrivacidad = new AvisoPrivacidad();

export default {

    data: function(){
        return{
            data: [],
        }
    },
    methods:{
      async AvisoPrivacidad() {
          try {
              const response = await _serviciosAvisoPrivacidad.getAvisoPrivacidad(mapFun.avisoPrivacidad);
              this.data = response.data;
          } catch (error) {
              console.log('error', error.message);
          }
      },
      urlRespuesta(api, IdAviso,Reporte,Descripcion){
        if(api == 1) {
          const url = "https://siahe."+ this.urlSubdominio +"/AVIPRI/Reportes/GenerarReporte.ashx?obj={'IdAviso':";
          return url + IdAviso +",'Reporte':"+ Reporte +",'Descripcion':'"+ Descripcion +"'}";
        }
        else if(api == 2){
          /*const url = "http://siahe2/AVIPRI/Reportes/GenerarReporte.ashx?obj={'IdAviso':";*/
          const url = "https://siahe."+ this.urlSubdominio +"/AVIPRI/Reportes/GenerarReporte.ashx?obj={'IdAviso':";
          return url + IdAviso +",'Reporte':"+ Reporte +",'Descripcion':'"+ Descripcion +"'}";
        }
        else{
          return this.urlServe + Descripcion;
        }
      }
    },
    components:{ botonAtras },
     mounted(){
      //  console.log();
      setTimeout(() => window.scrollTo(0, 0), 900)
       this.AvisoPrivacidad();
    },
}
</script>

<style scoped>

.card-header { background-color: #fff; }
.btn-link{ color: #474444; }
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }



li{
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */
    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    /*
    lo cambie a estilos.css
    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    } */
    /*

    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    } */
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }
    .img_fija{

    top: 10% !important;

}

@media only screen and (max-device-width : 900px) {
    /* .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    } */
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
